import { render, staticRenderFns } from "./FlipCarousel.vue?vue&type=template&id=319018e8&scoped=true"
import script from "./FlipCarousel.vue?vue&type=script&lang=js"
export * from "./FlipCarousel.vue?vue&type=script&lang=js"
import style0 from "./FlipCarousel.vue?vue&type=style&index=0&id=319018e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319018e8",
  null
  
)

export default component.exports